import { useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import { CRRender, Block } from "@/components/crRender";
import RequestDetailsSkeleton from "./widgets/skeleton/Skeleton";
import "./style.css";
import { GetBrokerMedicalRequestDetails } from "@/api/endpoints/Broker/BrokerRequest";
import PrevOffers from "./widgets/prevOffers";
import ChatWrapper from "./widgets/ChatWrapper";
import DataTable from "./components/dataTable";
import RequestInfo from "./components/requestInfo";
import { PATIENT_REQUEST_STATUS } from "@/data/status";
import { translate } from "@/utils/langUtils";
import { LoadListDefault, useGet } from "@/api/hooks";
import useNavs from "@/hooks/useNavs";


const MedicalRequestDetails = () => {
    const [isChatOpen, setIsChatOpen] = useState(false);
    const [selectedHospital, setSelectedHospital] = useState<any>(null);
    const [OpednedFiles, setOpednedFiles] = useState<any>(null);
    const [loading, setLoading] = useState(false);

    const popupRef = useRef<any>(null);
    const PrevRef = useRef<any>(null);

    const { navigate, params: { medicalOrderId } } = useNavs();

    const { result: requestDetails, isPending: isRequestDetailsLoading } = useGet({
        ...LoadListDefault,
        allowFetch: !!medicalOrderId,
        endPoint: GetBrokerMedicalRequestDetails,
        params: [medicalOrderId],
        defaultValue: {},
    })


    const proccedRequest = requestDetails?.availableProviders?.find((provider: any) => provider?.isAccepted);
    const handlePay = () => {
        const price = proccedRequest?.downPayment;
        /* 
                setLoading(true)
                RegisterOrder({
                    orderId: requestDetails?.orderId,
                    orderAmount: Number(price.toFixed(2)),
                    redirectToPage: Links.Medical.redirect(requestDetails?.id),
                }).then((res) => {
                    setLoading(false)
                    const redirectUrl = res.formUrl
                    window.location.href = redirectUrl
                }).catch((err) => {
                    console.log(err)
                    setLoading(false)
                }) */
    }



    return (
        <>
            <CRRender isRender={isRequestDetailsLoading}>
                <RequestDetailsSkeleton />
            </CRRender>


            < CRRender isRender={!isRequestDetailsLoading}>
                <div className="request-details-with-chat">
                    <div className="request-details-main-content">
                        <div className="request-details-page">
                            <div className="rd-back-link" onClick={() => navigate(-1)}>
                                <Icon icon="mdi:arrow-left" width={16} />
                                <span>{translate("Back to all requests")}</span>
                            </div>

                            <RequestInfo requestDetails={requestDetails} PrevRef={PrevRef} />

                            <DataTable setIsChatOpen={setIsChatOpen} setOpednedFiles={setOpednedFiles} setSelectedHospital={setSelectedHospital} requestStatusId={requestDetails?.orderStatusId} availableProviders={requestDetails?.availableProviders} />

                            <CRRender isRender={requestDetails?.orderStatusId == PATIENT_REQUEST_STATUS.AwaitingInitialPayment}>
                                <div className="rd-actions">
                                    <button disabled={!proccedRequest?.id} className="rd-proceed-btn" onClick={handlePay}>
                                        {loading ? <Icon icon="codex:loader" width={20} height={20} /> : translate("Proceed")}  {proccedRequest?.downPayment}
                                    </button>
                                </div>
                            </CRRender>
                            <CRRender isRender={requestDetails?.orderStatusId == PATIENT_REQUEST_STATUS.InProgress}>
                                <div className="rd-actions">
                                    <button disabled={!proccedRequest?.id} className="rd-proceed-btn" onClick={handlePay}>
                                        {loading ? <Icon icon="codex:loader" width={20} height={20} /> : translate("Complete Payment")} {proccedRequest?.downPayment}
                                    </button>
                                </div>
                            </CRRender>

                        </div>
                    </div>

                    <Block isRender={isChatOpen} className="request-details-chat-sidebar">
                        <ChatWrapper popupRef={popupRef} providerOrderId={OpednedFiles} setOpednedFiles={setOpednedFiles} setIsChatOpen={setIsChatOpen} isChatOpen={isChatOpen} />
                    </Block>

                </div>

                <PrevOffers PrevRef={PrevRef} requestId={requestDetails?.id} />
            </CRRender>
        </>
    );
};

export default MedicalRequestDetails;

